import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const Swiss = definePreset(Aura, {
  components: {
    autocomplete: {
      root: {
        focusBorderColor: 'transparent',
        hoverBorderColor: '{surface.400}',
        background: 'var(--colors-background-input)',
        borderRadius: 'var(--radius-input)',
      },
      option: {
        focusBackground: 'var(--colors-branding-red-accent)',
        selectedFocusBackground: 'var(--colors-branding-red-accent)',
        selectedBackground: 'var(--colors-branding-red-accent)',
        focusColor: 'var(--colors-text-white)',
        selectedFocusColor: 'var(--colors-text-white)',
        selectedColor: 'var(--colors-text-white)',
        borderRadius: 'var(--radius-xl)',
      },
      overlay: {
        borderRadius: 'var(--radius-xl)'
      }
    },
    select: {
      root: {
        focusBorderColor: 'transparent',
        hoverBorderColor: 'transparent',
        background: 'var(--colors-background-input)',
        borderRadius: 'var(--radius-input)',
      },
      option: {
        focusBackground: 'var(--colors-branding-red-accent)',
        selectedFocusBackground: 'var(--colors-branding-red-accent)',
        selectedBackground: 'var(--colors-branding-red-accent)',
        focusColor: 'var(--colors-text-white)',
        selectedFocusColor: 'var(--colors-text-white)',
        selectedColor: 'var(--colors-text-white)',
      },
    },
    multiselect: {
      root: {
        focusBorderColor: 'transparent',
        hoverBorderColor: 'transparent',
        background: 'var(--colors-background-input)',
        borderRadius: 'var(--radius-input)',
      },
      option: {
        focusBackground: 'var(--colors-branding-sangria)',
        selectedFocusBackground: 'var(--colors-branding-sangria)',
        selectedBackground: 'var(--colors-branding-sangria)',
        focusColor: 'var(--colors-text-white)',
        selectedFocusColor: 'var(--colors-text-white)',
        selectedColor: 'var(--colors-text-white)',
      },
      overlay: {
        borderRadius: 'var(--radius-xl)',
      },
    },
    inputtext: {
      root: {
        focusBorderColor: 'transparent',
      },
    },
    datepicker: {
      date: {
        selectedBackground: 'var(--colors-branding-red-accent)',
        selectedColor: 'var(--colors-text-white)',
        borderRadius: 'var(--radius-lg)',
      },
    },
    toast: {
      root: {
        width: '25rem',
        borderRadius: '{border.radius.lg}',
        borderWidth: '1px',
      },
      content: {
        gap: '0.5rem',
        padding: '1rem',
      },
      text: {
        gap: '0.25rem',
      },
      detail: {
        fontSize: '0.875rem',
        fontWeight: '500',
      },
      icon: {
        size: '1.125rem',
      },
      success: {
        background: 'var(--colors-background-toast-success)',
        borderColor: 'var(--colors-border-toast-success)',
        color: 'var(--colors-text-toast-success)',
      },
      error: {
        background: 'var(--colors-background-toast-error)',
        borderColor: 'var(--colors-border-toast-error)',
        color: 'var(--colors-text-toast-error)',
      },
      info: {
        background: 'var(--colors-background-toast-info)',
        borderColor: 'var(--colors-border-toast-info)',
        color: 'var(--colors-text-toast-info)',
      },
      warn: {
        background: 'var(--colors-background-toast-warning, #fff4e5)',
        borderColor: 'var(--colors-border-toast-warning, #ff9800)',
        color: 'var(--colors-text-toast-warning, #663c00)',
      },
    },
  },
});

export default Swiss;
